import { getToken } from '@nxtpeople/nxt-vue-keycloak';
import axios, { AxiosRequestHeaders, AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { notifyError } from '../helpers/notification.helper';
import i18n from '../i18n';
import router from '../router';
import store from '../store';

const authRequestInterceptor = async function (config: InternalAxiosRequestConfig) {
   const token = await getToken();

   config.headers = {
      Authorization: `Bearer ${token}`,
      Accept: `application/json`,
      'Content-Type': 'application/json',
      ...config.headers,
   } as AxiosRequestHeaders;

   return config;
};

const authResponseSuccessInterceptors = async function (response: AxiosResponse) {
   // if code is empty resonse is valid
   if (response && response?.status === 204) return response;

   if (response && response?.data) {
      return response;
   } else {
      if (response?.status >= 200 && response?.status < 300) return response;

      notifyError({ title: 'API responded with no data!' });
      return Promise.reject(new Error('API responded with no data!'));
   }
};

const authResponseErrorInterceptors = async function (error: any) {
   if (axios.isCancel(error)) return await Promise.reject(error);

   // Network errors, timeouts and CORS failures have no response at all
   if (!error.response) return await Promise.reject(error);

   const { status, headers } = error.response;

   if (status === 401) {
      router.push({
         name: 'Error',
         query: {
            error_code: '401',
            error_title: i18n.global.t('errors.account-not-found'),
            error_message: `${store.getters.isDev ? `${JSON.stringify(error)}` : i18n.global.t('generic.account-not-found-description')}`,
            error_action: 'logout',
         },
      });
   }

   if (status === 503 && !headers?.location) {
      router.push({
         name: 'Unavailable',
      });
   }

   return await Promise.reject(error);
};

export { authRequestInterceptor, authResponseErrorInterceptors, authResponseSuccessInterceptors };
